import "./Info.css"

type InfoProps = {
  title: string
  subtitle?: string
}

export default function Info({ title, subtitle }: InfoProps) {
  return (
    <section className="bf-info-wrapper">
      <h2 className="bf-info-bold-text">{title}</h2>
      {subtitle ? <p className="bf-info-text">{subtitle}</p> : null}
    </section>
  )
}
